module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.5bc6b836.ttf";